import { ColumnDef } from "@tanstack/react-table";
import { format } from "date-fns";

import { Loan } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";

import { Badge } from "@/components/ui/badge/badge";
import { DataTableRowActions } from "./data-table-row-actions";
import { datesMatch } from "@/utils";

export const columns: ColumnDef<Loan, any>[] = [
  {
    accessorKey: "createdAt",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => (
      <div className="w-[220px] flex flex-col">
        <span>{row.index + 1}</span>
        <span className="text-xs">
          (Loan taken at - {format(row.getValue("createdAt"), "PPP")} )
        </span>
      </div>
    ),
    enableSorting: false,
    enableHiding: false,

    filterFn: (row, id, value) => {
      return datesMatch(row.getValue(id), value);
    },
  },
  {
    accessorKey: "employeeName",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Employee" />
    ),
    cell: ({ row }) => (
      <div className="flex flex-col gap-1">
        <span>{row.getValue("employeeName")}</span>
        <span className="text-xs">{row.original?.employeeEmail}</span>
      </div>
    ),
    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id));
    },
    enableSorting: false,
  },

  {
    accessorKey: "totalAmountRequested",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Amount Requested" />
    ),
    cell: ({ row }) => <div>{row.getValue("totalAmountRequested")}</div>,
    enableColumnFilter: false,
    enableSorting: false,
  },
  {
    accessorKey: "totalAmountApproved",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Amount Approved" />
    ),
    cell: ({ row }) => <div>{row.getValue("totalAmountApproved")}</div>,
    enableColumnFilter: false,
    enableSorting: false,
  },
  {
    accessorKey: "remainingBalance",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Remaining Balance" />
    ),
    cell: ({ row }) => <div>{row.getValue("remainingBalance")}</div>,
    enableColumnFilter: false,
    enableSorting: false,
  },

  {
    accessorKey: "status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => (
      <div>
        <Badge variant="outline">{row.getValue("status")}</Badge>
      </div>
    ),
    enableColumnFilter: false,
    enableSorting: false,
  },

  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
